module.exports = "//a.spikex.com/sigma/frontend-ssr-web-user-center/_next/static/images/newbackground-dark-b445a340652354511a54339f99f55b03.jpg";